"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
exports.isNilOrEmpty = function (obj) { return ramda_1.isNil(obj) || ramda_1.isEmpty(obj); };
exports.isNotNilOrEmpty = function (obj) { return !ramda_1.isNil(obj) && !ramda_1.isEmpty(obj); };
//# sourceMappingURL=utils.js.map